
/* delivery window = today + N working days, from the 3PL quote */
(function(){function add(d,n){var x=new Date(d);while(n>0){x.setDate(x.getDate()+1);if(x.getDay()!==0&&x.getDay()!==6)n--;}return x;}
var f={weekday:'short',month:'short',day:'numeric'};document.querySelectorAll('[data-ship-days]').forEach(function(e){e.textContent=add(new Date(),parseInt(e.getAttribute('data-ship-days'),10)).toLocaleDateString('en-US',f);});})();
/* bundle radio toggle + price line follows the selected tier */
(function(){var pl=document.getElementById('priceline');
function sync(o){if(!pl)return;var was=o.getAttribute('data-was'),sv=o.getAttribute('data-save');pl.innerHTML='<b>'+o.getAttribute('data-price')+'</b>'+(was?'<s>'+was+'</s>':'')+(sv?'<span class="save">'+sv+'</span>':'');
var sp=document.getElementById('stickyPrice'),sn=document.getElementById('stickyNote');if(sp){sp.textContent=o.getAttribute('data-price');sn.textContent=o.getAttribute('data-tier');}
var sw=document.getElementById('stickyWas'),ss=document.getElementById('stickySave');if(sw)sw.textContent=was||'';if(ss)ss.textContent=sv?'· '+sv:'';
var pf=document.getElementById('pricelineFinal');if(pf)pf.innerHTML=pl.innerHTML;}
document.querySelectorAll('.opt').forEach(function(o){o.addEventListener('click',function(){document.querySelectorAll('.opt').forEach(function(x){x.classList.remove('on');});o.classList.add('on');sync(o);});});
var on=document.querySelector('.opt.on');if(on)sync(on);})();
/* mobile sticky bar once the buy button scrolls out */
(function(){var st=document.getElementById('sticky'),btn=document.querySelector('.buy .atc');if(!st||!btn)return;
function chk(){var r=btn.getBoundingClientRect();var out=r.bottom<0;var nearEnd=(window.innerHeight+window.scrollY)>(document.body.scrollHeight-700);var fin=document.querySelector('.final'),fr=fin?fin.getBoundingClientRect():null;var finalOn=fr&&fr.top<window.innerHeight&&fr.bottom>0;st.classList.toggle('show',out&&!nearEnd&&!finalOn);}
window.addEventListener('scroll',chk);window.addEventListener('resize',chk);chk();})();
/* gallery: thumbs + arrows + keyboard */
(function(){var thumbs=Array.prototype.slice.call(document.querySelectorAll('.thumbs > div')).filter(function(t){return t.querySelector('img');});var main=document.querySelector('.gallery .main img');if(!main||!thumbs.length)return;
function show(i){i=(i+thumbs.length)%thumbs.length;main.src=thumbs[i].querySelector('img').src;thumbs.forEach(function(x){x.classList.remove('on');});thumbs[i].classList.add('on');}
function cur(){return Math.max(0,thumbs.findIndex(function(t){return t.classList.contains('on');}));}
thumbs.forEach(function(t,i){t.addEventListener('click',function(){show(i);});});
var l=document.querySelector('.gallery .arrow.l'),r=document.querySelector('.gallery .arrow.r');
if(l)l.addEventListener('click',function(){show(cur()-1);});if(r)r.addEventListener('click',function(){show(cur()+1);});
document.addEventListener('keydown',function(e){if(e.key==='ArrowLeft')show(cur()-1);if(e.key==='ArrowRight')show(cur()+1);});})();
/* review cards: real swipe carousel on phones (dots + arrows follow the scroll) */
(function(){var box=document.getElementById('rev3'),dots=document.getElementById('revdots');if(!box||!dots)return;
var cards=[].slice.call(box.children),n=cards.length;if(!n)return;
function step(){return n>1?(cards[1].offsetLeft-cards[0].offsetLeft):box.clientWidth;}
function idx(){var st=step();return st?Math.max(0,Math.min(n-1,Math.round(box.scrollLeft/st))):0;}
function go(i){i=(i+n)%n;box.scrollTo({left:i*step(),behavior:'smooth'});}
function mark(){var k=idx();[].forEach.call(dots.children,function(d,j){d.classList.toggle('on',j===k);});}
cards.forEach(function(c,i){var d=document.createElement('i');d.addEventListener('click',function(){go(i);});dots.appendChild(d);});
box.addEventListener('scroll',function(){window.requestAnimationFrame(mark);});
[].forEach.call(document.querySelectorAll('.rvb'),function(b){b.addEventListener('click',function(){go(idx()+parseInt(b.getAttribute('data-d'),10));});});
mark();})();


/* tabs: highlight the section in view */
(function(){var tabs=[].slice.call(document.querySelectorAll('.nav .tabs a'));if(!tabs.length||!('IntersectionObserver' in window))return;
var map={};tabs.forEach(function(a){var el=document.querySelector(a.getAttribute('href'));if(el)map[el.id]=a;});
var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){tabs.forEach(function(t){t.classList.remove('on');});var a=map[e.target.id];if(a){a.classList.add('on');}}});},{rootMargin:'-30% 0px -60% 0px'});
Object.keys(map).forEach(function(id){io.observe(document.getElementById(id));});})();

/* Shopify Ajax cart. Monetary values always come from Shopify's response. */
(function () {
  'use strict';
  const $ = id => document.getElementById(id);
  const cart = $('cart'), ov = $('cartov');
  if (!cart || !ov) return;
  const variant = 51214202765564;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let state = null, busy = false, lastFocus;
  const error = document.createElement('p');
  error.id = 'cartError'; error.setAttribute('role', 'alert'); error.hidden = true;
  error.style.cssText = 'color:#7A1F3D;padding:12px 22px;margin:0;font-size:14px';
  $('cartFull').parentNode.insertBefore(error, $('cartFull'));
  const usd = cents => '$' + (cents / 100).toFixed(2);
  const line = () => state && state.items.find(i => i.variant_id === variant);
  function message(text) { error.textContent = text; error.hidden = !text; }
  async function request(path, body) {
    const res = await fetch(root + path, {method: body ? 'POST' : 'GET', credentials: 'same-origin', headers: {'Accept':'application/json', ...(body ? {'Content-Type':'application/json'} : {})}, ...(body ? {body: JSON.stringify(body)} : {})});
    const data = await res.json();
    if (!res.ok || data.status >= 400) throw new Error(data.description || data.message || 'Unable to update your cart. Please try again.');
    return data;
  }
  function draw() {
    const item = line(), n = item ? item.quantity : 0;
    $('cartFull').hidden = !item; $('cartEmpty').hidden = !!item; $('cartFt').hidden = !item;
    $('bagN').hidden = !(state && state.item_count); $('bagN').textContent = state ? state.item_count : '';
    $('cartCount').textContent = n ? '· ' + n + (n > 1 ? ' kits' : ' kit') : '';
    if (!item) return;
    const subtotal = item.final_line_price, retail = 9999 * n, shipping = n >= 3 ? 0 : 799;
    $('cartVar').textContent = n + (n > 1 ? ' Kits' : ' Kit') + ' · ' + usd(subtotal / n) + ' per kit';
    $('qVal').textContent = n;
    $('qMinus').disabled = busy || n <= 1; $('qPlus').disabled = busy || n >= 5;
    $('cartTag').hidden = true;
    $('cartPrice').textContent = usd(subtotal); $('cartWas').textContent = usd(retail);
    $('cartSave').textContent = 'SAVE ' + Math.round((1 - subtotal / retail) * 100) + '%';
    $('cartShip').innerHTML = shipping ? usd(shipping) : '<span class="free">FREE</span>';
    $('cartTotWas').textContent = usd(retail + shipping);
    $('cartTot').textContent = usd(state.total_price + shipping);
    const invalid = state.currency !== 'USD' || n > 5 || state.items.length !== 1 || subtotal !== [0,5999,9598,11998,15597,17997][n];
    $('cartCo').disabled = busy || invalid;
    if (invalid) message(state.currency !== 'USD' ? 'USD checkout is not available yet.' : 'Your cart pricing needs to be refreshed before checkout. Please contact support@shopblissit.com.');
  }
  function open() {
    lastFocus = document.activeElement; cart.classList.add('open'); ov.classList.add('open');
    cart.setAttribute('aria-hidden','false'); document.documentElement.classList.add('cartlock'); $('cartX').focus();
  }
  function close() {
    cart.classList.remove('open'); ov.classList.remove('open'); cart.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('cartlock'); if (lastFocus) lastFocus.focus();
  }
  async function refresh() { state = await request('cart.js'); draw(); }
  async function action(fn) {
    if (busy) return; busy = true; message('');
    document.querySelectorAll('.atc:not(.co)').forEach(b => b.disabled = true); draw();
    try { await fn(); } catch(e) { message(e.message); }
    finally { busy = false; document.querySelectorAll('.atc:not(.co)').forEach(b => b.disabled = false); draw(); }
  }
  async function quantity(n) {
    await action(async () => { const item = line(); if (!item) return; state = await request('cart/change.js', {id:item.key,quantity:Math.max(0,Math.min(5,n))}); });
  }
  document.querySelectorAll('.atc:not(.co)').forEach(b => b.addEventListener('click', e => {
    e.preventDefault(); open(); action(async () => {
      await refresh();
      if (state.currency !== 'USD') throw new Error('USD checkout is not available yet.');
      const selected = document.querySelector('#buy .opt.on');
      const n = parseInt(selected && selected.getAttribute('data-tier'),10) || 1;
      const item = line();
      if (item) state = await request('cart/change.js', {id:item.key,quantity:n});
      else { await request('cart/add.js', {items:[{id:variant,quantity:n}]}); await refresh(); }
    });
  }));
  $('bagBtn').addEventListener('click', e => {e.preventDefault();open();action(refresh);});
  $('cartX').addEventListener('click',close); ov.addEventListener('click',close);
  $('cartRm').addEventListener('click',()=>quantity(0));
  $('qPlus').addEventListener('click',()=>quantity(line().quantity+1));
  $('qMinus').addEventListener('click',()=>quantity(line().quantity-1));
  $('cartCo').addEventListener('click', e => {e.preventDefault();if (!busy && !$('cartCo').disabled) window.location.assign(root+'checkout');});
  document.addEventListener('keydown',e => {
    if (!cart.classList.contains('open')) return;
    if(e.key==='Escape')close();
    if(e.key==='Tab') {
      const els=[...cart.querySelectorAll('button:not([disabled]),a[href],input')].filter(x=>x.getClientRects().length);
      if(e.shiftKey && document.activeElement===els[0]) {e.preventDefault();els[els.length-1].focus();}
      else if(!e.shiftKey && document.activeElement===els[els.length-1]) {e.preventDefault();els[0].focus();}
    }
  });
  refresh().catch(()=>{});
})();
